"use client"

import { useContext } from 'react'
import * as React from "react"
import { cn } from "@/lib/utils"
import Marquee from "react-fast-marquee"
import { motion, useAnimation, useInView } from "framer-motion";
import { trackEvent } from '../../analytics'
import { advertiserAnalyticOptions } from '@/utils/functions'
import { isMobile } from '@/lib/utils'
import { SharedContext } from '@/context/SharedContext'
import { AdvertiserContext } from '@/context/AdvertiserContext'
import Image from 'next/image'


interface Iprops {
	categories: typeof Object,
	locations: typeof Object
}



export default function Services({ categories, locations }: Iprops) {

	const ref = React.useRef(null);
	const isInView = useInView(ref, { once: true });
	const control = useAnimation();
	React.useEffect(() => {
		if (isInView) {
			control.start("visible")
		}
	}, [isInView])

	const {
  cookie,
  utmParams
} = useContext(SharedContext);

 const {
  enterpriseLoginDetails
} = useContext(AdvertiserContext);
	
	return (
		<section className="px-[0px] space-y-[48px] lg:space-y-[150px] md:space-y-[100px] py-[40px] md:py-[0px]">
			<div className={"space-y-[32px] md:space-y-[48px]"}>
				<motion.h1
					ref={ref}
					variants={{ hidden: { opacity: 0, y: 90 }, visible: { opacity: 1, y: 0 } }}
					transition={{ duration: 0.4 }}
					initial={"hidden"}
					animate={control}
					className="text-center w-[39%] md:w-full primaryTitle">Hire from 300+ Job roles</motion.h1 >
				<div
					ref={ref}
					className={"space-y-[16px]"}>
					<Marquee pauseOnHover={true} pauseOnClick={true} speed={75}>
						<div className={"flex flex-row"}>
							{(Object.values(categories).slice(0, categories.length / 2)).map((item, index) => {
								return item?.image_url && <motion.div	
									variants={{
										hidden: { opacity: 0, x: 90 },
										visible: { opacity: 1, x: 0 }
									}}
									onClick={()=>{
										trackEvent({ name: 'tap_role', searchParams: utmParams || {}, options: {...advertiserAnalyticOptions({ enterprise: !!enterpriseLoginDetails?.advertiserId,category:"tap"}),device_type:isMobile()?"mobile":"web",label:"landing_page",section:"job_role_cta"}})

										
									}}
									transition={{ duration: 0.2 * index, delay: 0.2 * index }}
									initial={"hidden"}
									animate={control}
									key={`item-${index + 1}`} className="basis-[auto]">
									<a
										href={"#banner-section"}
										className={cn(
											"w-max bg-blocks p-[12px] rounded-[8px] flex justify-start items-center gap-x-[12px] cursor-pointer border-none shadow-none mr-[16px] no-underline",
										)}
										// onClick={() => {
										// 	cookie.set('userState', item?.id != undefined ? item?.id : '', { path: '/' })
										// }}
									>
										<Image
											src={item.image_url}
											className={
												"w-[48px] h-[48px] md:w-[56px] md:h-[56px] rounded-[8px] object-cover object-center"
											}
											width={100}
											height={100}
											alt={"service_image"}
										/>
										<p className={"notoSansBold text-[18px] leading-[28px] text-title mb-[0px]"}>
											{item.english_name}
										</p>
									</a>
								</motion.div>
 							} )}
						</div>
					</Marquee>
					<Marquee pauseOnHover={true} pauseOnClick={true} speed={75}>
						<div className={"flex flex-row"}>
							{(Object.values(categories).slice(categories.length / 2, categories.length)).map((item, index) => {
								return item?.image_url && <motion.div
									onClick={()=>{
										trackEvent({ name: 'tap_role', searchParams: utmParams || {}, options: {...advertiserAnalyticOptions({ enterprise: !!enterpriseLoginDetails?.advertiserId,category:"tap"}),device_type:isMobile()?"mobile":"web",label:"landing_page",section:"job_role_cta"}})									}}
									variants={{
										hidden: { opacity: 0, x: 90 },
										visible: { opacity: 1, x: 0 }
									}}
									transition={{ duration: 0.2 * index, delay: 0.2 * index }}
									initial={"hidden"}
									animate={control}
									key={`item-${index + 1}`} className="basis-[auto]">
									<a
										href={"#banner-section"}
										className={cn(
											"w-max bg-blocks p-[12px] rounded-[8px] flex justify-start items-center gap-x-[12px] cursor-pointer border-none shadow-none mr-[16px] no-underline",
										)}
									>
										<Image
											src={item.image_url}
											className={
												"w-[48px] h-[48px] md:w-[56px] md:h-[56px] rounded-[8px] object-cover object-center"
											}
											width={100}
											height={100}
											alt={"service_image"}
										/>
										<p className={"notoSansBold text-[18px] leading-[28px] text-title mb-[0px]"}>
											{item.english_name}
										</p>
									</a>
								</motion.div>
 							} )}
						</div>
					</Marquee>
				</div>
			</div>
			<div className={"space-y-[32px] md:space-y-[48px] lg:px-[64px] md:px-[40px] px-[16px]"}>
				<motion.h1
					ref={ref}
					variants={{ hidden: { opacity: 0, y: 90 }, visible: { opacity: 1, y: 0 } }}
					transition={{ duration: 0.4, delay:0.7 }}
					initial={"hidden"}
					animate={control}
					className="text-center w-[90%] md:w-full primaryTitle">
					Candidates of over 250+ districts from {Object.values(locations).length} states
				</motion.h1>
				<div
					ref={ref}
					className={
						"flex flex-wrap justify-center items-center gap-[16px] md:gap-x-[32px]  md:gap-y-[20px]"
					}
				>
					{Object.values(locations).sort(item => -item.is_active).map((item, index) => (
						<motion.a
							variants={{
								hidden: { opacity: 0, y: 95 },
								visible: { opacity: 1, y: 0 }
							}}
							transition={{ duration: 0.2 * index, delay: 0.3 * index }}
							initial={"hidden"}
							animate={control}
							key={`item-${index + 1}`}
							href={"#banner-section"}
							className={
								"w-[47%] md:w-[224px] h-[80px] bg-blocks p-[12px] rounded-[8px] justify-center items-center flex flex-wrap flex-col cursor-pointer no-underline"
							}
							onClick={() => {
								trackEvent({ name: 'tap_location', searchParams: utmParams || {}, options: {...advertiserAnalyticOptions({ enterprise: !!enterpriseLoginDetails?.advertiserId,category:"tap"}),device_type:isMobile()?"mobile":"web",label:"landing_page",section:"state_cta"}})	
								
								
							}}
						>
							<p className="mb-[0px] text-[16px] leading-[24px] md:text-[18px] md:leading-[28px] text-title text-center notoSansBold">{item.english_title}</p>
							{!item.is_active && <p className={"custom-text-state mb-[0px]"}>Coming Soon</p>}
						</motion.a>
					))}
				</div>
			</div>
		</section>
	)
}
